/**
 * Exclude fields with provided values from object.
 */
export const cleanObj = <T extends Record<string, any>>(obj: T, exclude: any[] = [undefined, null, '']): Partial<T> => {
  const cleanObj = { ...obj };

  Object.keys(cleanObj).forEach((key) => {
    const value = cleanObj[key];

    if (exclude?.includes(value)) {
      delete cleanObj[key];
    }
  });

  return cleanObj;
};
